import React from 'react';
import classes from './FullBackground.module.css';

const fullBackground = (props) => (
	<div className={classes.Background}></div>
)

export default fullBackground;